import React from "react";
import PropTypes from "prop-types";

const CommentBox = (props) => {
  const { comment, commentChanged } = props;

  const handleChange = (e) => {
    const inputText = e.target.value;
    commentChanged(inputText);
  };

  return (
    <div className="varsome-typeahead">
      <label className="tw-text-base tw-mb-0">
        Please add some information to put your classification into context (50
        characters minimum).
        <span className="tw-text-xs tw-block tw-italic">
          Did you observe this variant in a patient? Did the patient present
          with specific phenotypes? What information did you use to conclude
          that the variant should be classified in this way? However, do not
          enter any personally identifiable information for an individual.
        </span>
      </label>
      <textarea
        className="form-control"
        placeholder="Comment..."
        rows="6"
        value={comment}
        onChange={(e) => handleChange(e)}
      />
      <p
        className={
          comment && comment.length > 49 ? "tw-text-primary" : "tw-text-red-700"
        }
      >
        {comment ? comment.length : 0} / 50
      </p>
    </div>
  );
};

CommentBox.propTypes = {
  commentChanged: PropTypes.func.isRequired,
  comment: PropTypes.string,
};

CommentBox.defaultProps = {
  comment: null,
};

export default CommentBox;
